import { ApplicationRef, DoBootstrap, inject, NgModule, provideAppInitializer } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { ExternalLoginErrorComponent } from './app/external-login-error/external-login-error.component';
import { ForgotPasswordComponent } from './app/forgot-password/forgot-password.component';
import { LoginFormComponent } from './app/login-form/login-form.component';
import { LogoutComponent } from './app/logout/logout.component';
import { ResetPasswordComponent } from './app/reset-password/reset-password.component';
import { SsoMaxSessionsComponent } from './app/sso-max-sessions/sso-max-sessions.component';
import { SsoOptionsComponent } from './app/sso-options/sso-options.component';
import { SsoVerifyAccountComponent } from './app/sso-verify-account/sso-verify-account.component';
import { TwoFactorSelectionComponent } from './app/two-factor-selection/two-factor-selection.component';
import { globals } from './globals';

@NgModule({
  imports: [
    BrowserModule,
    LoginFormComponent,
    NoopAnimationsModule,
    SsoVerifyAccountComponent,
    SsoOptionsComponent,
    ExternalLoginErrorComponent,
    ForgotPasswordComponent
  ],
  providers: [
    FormBuilder,
    provideAppInitializer(() => {
      const iconRegistry = inject(MatIconRegistry);
      iconRegistry.setDefaultFontSetClass('material-symbols-outlined')
    }),
  ],
})
export class AppModule implements DoBootstrap {
  ngDoBootstrap(appRef: ApplicationRef): void {
    // Since the output JS is loaded on all pages, but the login form only exists on the login page,
    // this checks to see if the login form should be bootstrapped.
    if (globals.bootstrapLoginComponent) {
      appRef.bootstrap(LoginFormComponent);
    }

    if (globals.bootstrapSsoVerifyAccountComponent) {
      appRef.bootstrap(SsoVerifyAccountComponent);
    }

    if (globals.bootstrapSsoOptionsComponent) {
      appRef.bootstrap(SsoOptionsComponent);
    }

    if (globals.bootstrapExternalLoginErrorComponent) {
      appRef.bootstrap(ExternalLoginErrorComponent);
    }

    if (globals.bootstrapSsoMaxSessionsComponent) {
      appRef.bootstrap(SsoMaxSessionsComponent);
    }

    if (globals.bootstrapResetPasswordComponent) {
      appRef.bootstrap(ResetPasswordComponent);
    }

    if (globals.bootstrapForgotPasswordComponent) {
      appRef.bootstrap(ForgotPasswordComponent);
    }

    if (globals.bootstrapTwoFactorSelectionComponent) {
      appRef.bootstrap(TwoFactorSelectionComponent);
    }

    if (globals.bootstrapLogoutComponent) {
      appRef.bootstrap(LogoutComponent);
    }
  }
}
